(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  (() => {
    const buttonSelector = '[data-wholesale-price-guard]';
    const minimumWaitMs = 1000;
    const fallbackWaitMs = 5000;

    /* DHPS 14-10-2026: lege winkelwagen = afrekenknop altijd uit, ook als de laatste regel zonder
       herladen is verwijderd (Dawn rendert de knop dan niet opnieuw) */
    const cartIsEmpty = () => {
      const footer = document.getElementById('main-cart-footer');
      return !!(footer && footer.classList.contains('is-empty'));
    };

    const syncEmptyState = () => {
      if (!cartIsEmpty()) return;
      document.querySelectorAll('#main-cart-footer #checkout').forEach((button) => {
        if (!button.disabled) button.disabled = true;
      });
    };

    const initializeButton = (button) => {
      if (button.dataset.wholesalePriceGuardInitialized === 'true') return;

      button.dataset.wholesalePriceGuardInitialized = 'true';
      button.disabled = true;
      button.setAttribute('aria-disabled', 'true');
      button.setAttribute('aria-busy', 'true');

      const startedAt = Date.now();
      let released = false;

      const enableButton = () => {
        if (released || !button.isConnected || cartIsEmpty()) return;

        released = true;
        button.disabled = false;
        button.removeAttribute('aria-disabled');
        button.removeAttribute('aria-busy');

        window.removeEventListener(
          'samitaWSRenderWholesaleCompleted',
          handleWholesaleReady
        );
      };

      const releaseAfterMinimumWait = () => {
        const elapsedTime = Date.now() - startedAt;
        const remainingWait = Math.max(0, minimumWaitMs - elapsedTime);

        window.setTimeout(enableButton, remainingWait);
      };

      const handleWholesaleReady = () => {
        releaseAfterMinimumWait();
      };

      window.addEventListener(
        'samitaWSRenderWholesaleCompleted',
        handleWholesaleReady,
        { once: true }
      );

      window.setTimeout(enableButton, fallbackWaitMs);
    };

    const initializeCheckoutButtons = () => {
      document
        .querySelectorAll(buttonSelector)
        .forEach(initializeButton);
      syncEmptyState();
    };

    if (document.readyState === 'loading') {
      document.addEventListener(
        'DOMContentLoaded',
        initializeCheckoutButtons,
        { once: true }
      );
    } else {
      initializeCheckoutButtons();
    }

    const observer = new MutationObserver(initializeCheckoutButtons);

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class']
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
